import React from "react";
import { useNavigate } from "react-router-dom";
import { Brain } from "lucide-react";
import { Button } from "../ui/button";
import { useS } from "../../lib/simple";

export function GoFurther({ onLater }) {
  const { s } = useS();
  const nav = useNavigate();
  return (
    <div className="lb-card p-5" data-testid="go-further-card">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-primary/15 text-neon flex items-center justify-center shrink-0"><Brain size={20} /></div>
        <div className="min-w-0">
          <p className="font-display font-bold text-lg leading-tight">{s("further_title")}</p>
          <p className="text-sm text-[hsl(var(--muted-foreground))] mt-1">{s("further_sub")}</p>
        </div>
      </div>
      <div className="flex gap-2 mt-4">
        <Button onClick={() => nav("/app/diagnostic")} data-testid="go-further-diag" className="flex-1 rounded-full h-12 bg-gradient-to-r from-primary to-neon text-white lb-glow-btn font-semibold">
          {s("further_cta")}
        </Button>
        <Button onClick={onLater} data-testid="go-further-later" variant="outline" className="rounded-full h-12 px-5 border-white/10 bg-white/5">
          {s("later")}
        </Button>
      </div>
    </div>
  );
}
